module.exports = __webpack_public_path__ + "static/media/corner_left_bg.c57fa70e.svg";